window.addEventListener("load", () => {
  setTimeout(() => {
    const contents = document.getElementsByClassName("reviews");
    const content = contents.item(0);

    if (content === null) return;

    if (content.clientHeight <= 30) {
      const labelId = content.getAttribute("aria-labelledby");
      const label = document.getElementById(labelId);
      label.classList.add("hidden");
      label.classList.remove("show");
    }
  }, 1000);
});
